"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
/** Representing an API request. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var ApiRequest = /** @class */ (function () {
    /** Initializing underlying parameters. */
    function ApiRequest() {
        this.baseUrl = "";
        this.url = "";
        this.verb = "GET";
        this.data = {};
        this.query = {};
        this.headers = {};
        this.usingCredentials = false;
        this.isForm = false;
        this.isUsingLaravel = true;
    }
    /** Setting request verb. */
    ApiRequest.prototype.setVerb = function (verb) {
        this.verb = verb;
        return this;
    };
    /** Setting url. */
    ApiRequest.prototype.setUrl = function (url) {
        var queryIndex = url.indexOf("?");
        if (queryIndex === -1) {
            this.url = url;
            return this;
        }
        this.url = url.substring(0, queryIndex);
        var query = {};
        new URLSearchParams(url.substring(queryIndex)).forEach(function (value, key) {
            query[key] = value;
        });
        return this.addQuery(query);
    };
    /** Setting baseUrl used by this request.
     * @param {string} baseUrl
     * @returns {Request} */
    ApiRequest.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
        return this;
    };
    /** Appending to configured baseUrl.
     * @param {string} append
     * @returns {Request} */
    ApiRequest.prototype.appendToBaseUrl = function (append) {
        return this.setBaseUrl("".concat(this.baseUrl, "/").concat(append));
    };
    /**
     * Setting authorization bearer token.
     * @param {string} token
     * @returns {Request}
     */
    ApiRequest.prototype.setBearerToken = function (token) {
        return this.addHeaders({ Authorization: "Bearer ".concat(token) });
    };
    /** Adding data to request. */
    ApiRequest.prototype.addData = function (data) {
        this.data = __assign(__assign({}, this.data), data);
        return this;
    };
    /** Adding query to request. */
    ApiRequest.prototype.addQuery = function (query) {
        this.query = __assign(__assign({}, this.query), query);
        return this;
    };
    /** Adding headers to request. */
    ApiRequest.prototype.addHeaders = function (headers) {
        this.headers = __assign(__assign({}, this.headers), headers);
        return this;
    };
    /** Setting request as form data. */
    ApiRequest.prototype.asForm = function (isForm) {
        this.isForm = isForm;
        return this;
    };
    ApiRequest.prototype.usingLaravel = function (isUsingLaravel) {
        this.isUsingLaravel = isUsingLaravel;
        return this;
    };
    /** Telling if request should add cookies. */
    ApiRequest.prototype.withCredentials = function (isHavingCredentials) {
        this.usingCredentials = isHavingCredentials;
        return this;
    };
    /** Telling if request is having query. */
    ApiRequest.prototype.havingQuery = function () {
        return !this.isEmpty(this.query);
    };
    /** Telling if request is having data. */
    ApiRequest.prototype.havingData = function () {
        return !this.isEmpty(this.data);
    };
    /** Telling if request should send cookies. */
    ApiRequest.prototype.havingCredentials = function () {
        return this.usingCredentials;
    };
    /** Telling if request is having headers. */
    ApiRequest.prototype.havingHeaders = function () {
        return !this.isEmpty(this.headers);
    };
    /** Telling if given object is empty. */
    // eslint-disable-next-line class-methods-use-this
    ApiRequest.prototype.isEmpty = function (object) {
        return Object.keys(object).length === 0;
    };
    /** Transforming request to fetch API requests parameters. */
    ApiRequest.prototype.toFetchParams = function () {
        this.prepareForFetch();
        var params = { method: this.verb };
        if (this.havingData()) {
            params.body = this.isForm
                ? (0, helpers_1.toFormData)(this.data)
                : JSON.stringify(this.data);
        }
        if (this.havingHeaders()) {
            params.headers = this.headers;
        }
        if (this.havingCredentials()) {
            params.credentials = "include";
        }
        return params;
    };
    ApiRequest.prototype.prepareForFetch = function () {
        if (!this.isForm)
            return;
        if (!this.isUsingLaravel)
            return;
        if (this.verb !== "PUT" && this.verb !== "PATCH")
            return;
        this.addData({ _method: this.verb });
        this.setVerb("POST");
    };
    /** Transforming to fetch API url. */
    ApiRequest.prototype.getUrl = function () {
        var shouldAddSlash = this.baseUrl.charAt(this.baseUrl.length - 1) !== "/" && this.url !== "/";
        var url = "".concat(this.baseUrl).concat(shouldAddSlash ? "/" : "").concat(this.url);
        if (!this.havingQuery()) {
            return url;
        }
        return "".concat(url, "?").concat(new URLSearchParams(this.query).toString());
    };
    /** Transforming request to json. */
    ApiRequest.prototype.toJson = function () {
        return {
            verb: this.verb,
            baseUrl: this.baseUrl,
            url: this.url,
            url_with_query: this.getUrl(),
            query: this.query,
            headers: this.headers,
            data: this.data,
            usingCredentials: this.usingCredentials,
            isUsingLaravel: this.isUsingLaravel,
        };
    };
    return ApiRequest;
}());
exports.default = ApiRequest;
